const LeftArrow = (props: any) => (
	<svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M6.7 14.6998L8.1 13.2998L3.8 8.9998H16V6.9998H3.8L8.1 2.6998L6.7 1.2998L0 7.9998L6.7 14.6998Z"
			fill="#333333"
		/>
	</svg>
);
export default LeftArrow;
